// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_r6-0";
export var buttonContainer = "_r6-3";
export var cancelButton = "_r6-4";
export var headerSection = "_r6-6";
export var headerTitle = "_r6-9";
export var messageSideLeft = "_r6-1";
export var messageSideRight = "_r6-2";
export var orderNumberContainer = "_r6-7";
export var orderNumberLabel = "_r6-8";
export var submitButton = "_r6-5";